define('views/components/reseller/reseller',['require','backbone','text!templates/components/reseller/reseller.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/reseller/reseller.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'reseller-item'
    });
});
